// extracted by mini-css-extract-plugin
export default {"LoginButton":"LoginButton_LoginButton__i44rx"};